export default __webpack_public_path__ + "static/media/screen2.6c5cd10d.png";